import { useState } from "react";
import axios from "axios";
import { API_BASE } from "../lib/api";
import { toast } from "sonner";

export function useCheckout() {
  const [loadingId, setLoadingId] = useState(null);

  const checkout = async (id, lookup) => {
    if (loadingId) return;
    setLoadingId(id);
    try {
      const { data } = await axios.post(
        `${API_BASE}/api/payments/checkout`,
        { lookup_key: lookup, origin_url: window.location.origin },
        { withCredentials: true }
      );
      window.location.href = data.checkout_url;
    } catch {
      toast.error("Paiement indisponible pour le moment. Appelez-nous au 07 84 67 88 02.");
      setLoadingId(null);
    }
  };

  return { loadingId, checkout };
}
